import axios from '../utils/axios';

export default function reclaim(adminId, mgr_id, data) {
    return (
        axios.post('/admin/' + adminId + '/credits/manager/' + mgr_id + '/reclaim', data)
    )
}
